export const programData: any = [
{
    "type": "Computer Courses",
    "courses": [
    {
        "id":"1",
        "title":"ADCA (Advance Diploma in Computer Application)",
        "duration":"1 Year",
        "subjects":[
            "Computer Fundamental",
            "Microsoft Windows XP/ Vista/ 7/ 10/ 11/ Mac Operating System",
            "MS Office (Word, Excel, PowerPoint)",
            "Desktop Publishing (Adobe Pagemaker, Adobe Photoshop, Corel Draw)",
            "Hindi/ English Typing",
            "Scanning & Printing",
            "Manual Accounting",
            "Financial Accounting (Professional Tally 7.2, Tally 9.0)",
            "Typing Master",
            "Internet & E-mail",
            "Basic Computer Hardware Maintainance",
            "Personality Development Courses",
            "Project",
            "Examination"
            ]
          },

    {
        "id":"2",
        "title":"DCA (Diploma in Computer Application)",
        "duration":"6 Months",
        "subjects":[
            "Computer Fundamental",
            "Microsoft Windows XP/ Vista/ 7/ 10/ 11/ Mac Operating System",
            "MS Office (Word, Excel, PowerPoint)",
            "Internet & Email Technology",
            "Basic Computer Hardware Maintainance",
            "HTML",
            "Hindi/ English Typing",
            "Personality Development Courses",
            "Project",
            "Examination"
        ]
    },
    {
        "id":"3",
        "title":"AutoCAD (Diploma in Computer-Aided Designing)",
        "duration":"6 Months",
        "subjects":[
            "Computer Fundamental",
            "Microsoft Windows XP/ Vista/ 7/ 10/ 11/ Mac Operating System",
            "Introduction of AutoCAD",
            "Setting up your Drawing Environment",
            "Mastering in Co-Ordinate System",
            "Object Creation",
            "Controlling of Drawing Display",
            "Object Selection",
            "Drawing Precision",
            "Editing Object with Properties",
            "Managing Layers",
            "Text in AutoCAD",
            "Blocks, Styles & Xrels",
            "Annotation of Drawing using Dimension",
            "AutoCAD Design Center",
            "Creating a Layout to plot",
            "Plotting your Drawing",
            "Personality Development Courses",
            "3D MAX",
            "V-ray",
            "Post Production",
            "Project",
            "Examination"
        ]
    },
    {
        "id":"4",
        "title":"Diploma in Web Designing",
        "duration":"6 Months",
        "subjects":[
            "Computer Fundamental",
            "Microsoft Windows XP/ Vista/ 7/ 10/ 11/ Mac Operating System",
            "Concept of Web Designing",
            "Internet Concept(Web)",
            "IDE Platform",
            "Notepad",
            "Browsers",
            "Dream Weaver",
            "Visual Studio Code",
            "HTML",
            "DHTML",
            "CSS",
            "Project",
            "Examination"
        ]
    },
    {
        "id":"5",
        "title":"DTP (Desktop Publishing)",
        "duration":"6 Months",
        "subjects":[
            "Computer Fundamental",
            "Microsoft Windows XP/ Vista/ 7/ 10/ 11/ Mac Operating System",
            "Desktop Publishing (Adobe Pagemaker, Adobe Photoshop, Corel Draw)",
            "Internet & Email Technology",
            "Personality Development Courses",
            "Project",
            "Examination"
        ]
    },
    {
        "id":"6",
        "title":"DCA-T (Diploma in Computer Application with Tally)",
        "duration":"9 Months",
        "subjects":[
            "Computer Fundamental",
            "Microsoft Windows XP/ Vista/ 7/ 10/ 11/ Mac Operating System",
            "MS Office (Word, Excel, PowerPoint)",
            "Internet & E-mail",
            "Computer Network & Multimedia Concept",
            "Project in Microsoft Word",
            "Project in Microsoft Excel",
            "Financial Accounting",
            "Tally 5.4, 7.2 & 9.0",
            "Personality Development Courses",
            "Project",
            "Examination"
        ]
    },
    {
        "id":"7",
        "title":"PGDCA (Post Graduate Diploma in Computer)",
        "duration":"1 Year",
        "subjects":[
            "Computer Fundamental",
            "Microsoft Windows XP/ Vista/ 7/ 10/ 11/ Mac Operating System",
            "MS Office (Word, Excel, PowerPoint, Access(DBMS))",
            "Desktop Publishing (Adobe Pagemaker, Adobe Photoshop, Corel Draw)",
            "Application Programming in FoxPro",
            "C & C++ Programming",
            "Basic Computer Hardware Maintainance",
            "Accounting Package",
            "Internet & Email Technology",
            "Personality Development Courses",
            "Project",
            "Examination"
        ]
    },
    {
        "id":"8",
        "title":"DCHM (Diploma in Computer Hardware Maintainance)",
        "duration":"6 Months",
        "subjects":[
            "Computer Fundamental",
            "Microsoft Windows XP/ Vista/ 7/ 10/ 11/ Mac Operating System",
            "Basic Electronic",
            "History of Personal Computer",
            "PC Assembling & Troubleshooting & Diagnosing PC Components",
            "Overview of PC Operations",
            "BIOS (Basic Input Output System)",
            "Operating System Installation (Installation of Windows XP/ Vista/ 7/ 10/ 11/ Mac OS",
            "Diagnosing & Troubleshooting & PC Configuration",
            "Personality Development Courses",
            "Project",
            "Examination"
        ]

    },
    {
        "id":"9",
        "title":"DFA (Diploma & Financial Accounting)",
        "duration":"6 Months",
        "subjects":[
            "Computer Fundamental",
            "Microsoft Windows XP/ Vista/ 7/ 10/ 11/ Mac Operating System",
            "MS Office (Word, Excel, PowerPoint)",
            "Financial Accounting",
            "Inventory Management",
            "Manual Management",
            "Tally",
            "GST",
            "Income Tax",
            "Payroll",
            "Returns, Filling of Documents Under various Law",
            "Personality Development Courses",
            "Project",
            "Examination"
        ]
    },
        {
          "id": "10",
          "title": "ADCAG PRO (ADVANCE DIPLOMA IN COMPUTER APPLICATION & GRAPHICS PRO)",
          "duration": "12 MONTHS F",
          "subjects": [
            "undamental of Computer & Window, OS",
            "MS OFFICE (WORD, EXCEL, POWERPOINT)",
            "MS ACCESS, MS OUTLOOK, INTERNET",
            "TALLY ERP 9.0/TALLY PRIME",
            "ADOBE PHOTOSHOP, ILLUSTRATOR",
            "Advance Graphic (Canva Pro, Video Editing)"
          ]
        },
        {
          "id": "11",
          "title": "DCWD+ (DIPLOMA IN COMPUTER WEB DESIGNING+)",
          "duration": "6 MONTHS FUNDAMENTAL OF COMPUTER",
          "subjects": [
            "& WINDOW, OS",
            "MS OFFICE (WORD, EXCEL, POWERPOINT)",
            "MS ACCESS, INTERNET, OUTLOOK",
            "WORDPRESS - WEBSITE DESIGNING, LANDPAGE DESIGNING",
            "WORDPRESS - WOO COMMERCE STORE WEBSITE"
          ]
        },
        {
          "id": "12",
          "title": "BASIC CERTIFICATE COURSE IN COMPUTER OPERATING (BCCCO)",
          "duration": "1 MONTH COMPUTER FUNDAMENTALS",
          "subjects": [
            ", WINDOWS, OS, MS OFFICE(WORD, EXCEL, POWER POINT)"
          ]
        },
        {
          "id": "13",
          "title": "CERTIFICATE IN DESKTOP PUBLISHING",
          "duration": "03 MONTHS",
          "subjects": []
        },
        {
          "id": "14",
          "title": "ADVANCE DIPLOMA IN WEB DEVELOPMENT",
          "duration": "12 MONTHS JAVA",
          "subjects": [
            "HTML, CSS",
            "PHP, MYSQL",
            "JAVASCRIPT",
            "NODE JS, EXPRESS JS, MONGO DB, REACT JS, NEXT JS"
          ]
        },
        {
          "id": "15",
          "title": "Certificate Course In Corel Draw",
          "duration": "2 MONTHS",
          "subjects": [
            "."
          ]
        },
        {
          "id": "16",
          "title": "CERTIFICATE IN OFFICE AUTOMATION (COA)",
          "duration": "3 MONTHS COMPUTER FUNDAMENTALS",
          "subjects": [
            ", OPERATING SYSTEM (GUI BASED)",
            "MS WORD",
            "MS EXCEL",
            "MS POWERPOINT",
            "INTERNET, E-MAIL",
            "USE OF G SUITE APPLICATIONS(DOCS/SHEETS/SLIDES/FORMS/BLOGGER)",
            "TALLY ERP 9.0/PRIME"
          ]
        },
        {
          "id": "17",
          "title": "MASTER DIPLOMA IN COMPUTER APPLICATION (MDCA)",
          "duration": "15 MONTHS COMPUTER FUNDAMENTALS",
          "subjects": [
            ", IT, OS & WINDOWS",
            "MS OFFICE",
            "INTERNET, HTML",
            "TALLY ERP 9.0/PRIME",
            "PAGEMAKER, PHOTOSHOP, COREL DRAW",
            "SPOKEN ENGLISH SKILLS"
          ]
        },
        {
          "id": "18",
          "title": "CERTIFICATE COURSE IN COMPUTER",
          "duration": "3 MONTHS FUNDAMENTALS OF COMPUTER",
          "subjects": [
            ", IT, WINDOWS, OPERATING SYSTEM",
            "MS OFFICE",
            "INSTALLATION AND TROUBLESHOOTING",
            "INTERNET"
          ]
        },
        {
          "id": "19",
          "title": "ADCA PRO",
          "duration": "12 MONTHS COMPUTER FUNDAMENTALS",
          "subjects": [
            ", IT & WINDOWS",
            "MS WORD",
            "MS EXCEL",
            "MS POWERPOINT",
            "MS ACCESS, HTML",
            "PAGEMAKER, PHOTOSHOP, CORELDRAW",
            "TALLY ERP 9.0/TALLY PRIME",
            "VISUAL BASICS",
            "BASICS OF C++"
          ]
        },
        {
          "id": "20",
          "title": "DCA Pro",
          "duration": "6 MONTHS COMPUTER FUNDAMENTALS",
          "subjects": [
            ", IT & WINDOWS",
            "MS WORD",
            "MS EXCEL",
            "MS POWERPOINT",
            "MS ACCESS",
            "HTML",
            "TALLY ERP 9.0/TALLY PRIME"
          ]
        },
        {
          "id": "21",
          "title": "DCA + Graphics",
          "duration": "6 MONTHS COMPUTER FUNDAMENTALS",
          "subjects": [
            ", IT & WINDOWS",
            "MS WORD",
            "MS EXCEL",
            "MS POWERPOINT",
            "MS ACCESS",
            "HTML",
            "PAGEMAKER",
            "PHOTOSHOP",
            "COREL DRAW"
          ]
        },
        {
          "id": "22",
          "title": "JavaScript",
          "duration": "3 MONTHS",
          "subjects": [
            "."
          ]
        },
        {
          "id": "23",
          "title": "COMPUTER BASIC COURSE (CBC)",
          "duration": "3 MONTHS FUNDAMENTALS OF COMPUTER",
          "subjects": [
            ", IT, WINDOWS & OS",
            "MS WORD",
            "MS EXCEL",
            "MS POWERPOINT, MS OUTLOOK",
            "MS ACCESS, INTERNET"
          ]
        },
        {
          "id": "24",
          "title": "MASTER DIPLOMA IN COMPUTER INFORMATION & SYSTEM MANAGEMENT (MDCIM)",
          "duration": "18 MONTHS COMPUTER FUNDAMENTALS",
          "subjects": [
            ", WINDOWS, OS",
            "MS OFFICE (WORD, EXCEL, POWERPOINT), INTERNET",
            "HTML, JAVA, DHTML, VB SCRIPT, FRONT PAGE",
            "ADOBE PAGEMAKER, PHOTOSHOP, CORELDRAW & SCANNING",
            "TALLY ERP 9.0/TALLY PRIME WITH GST",
            "BASICS OF PROGRAMMING IN C, C++, VISUAL BASICS",
            "INTERNET, SOFTWARE INSTALLATION, COMPUTER HARDWARE",
            "PERIPHERAL, DIAGNOSTIC TOOLS, ADVANCE TOPIC, AUDIO VISUAL, MS-DOS"
          ]
        },
        {
          "id": "25",
          "title": "DIPLOMA COURSE IN WEB DESIGNING (DCWD)",
          "duration": "6 MONTHS FUNDAMENTALS OF COMPUTER",
          "subjects": [
            "& WINDOWS (OS)",
            "MS WORD",
            "MS EXCEL",
            "MS POWERPOINT",
            "MS ACCESS, OUTLOOK & INTERNET",
            "HTML-5, CSS-3",
            "JAVA SCRIPT",
            "BOOTSTRAP/J-QUERY"
          ]
        },
        {
          "id": "26",
          "title": "DIPLOMA IN COMPUTER APPLICATION & GRAPHIC DESIGNING (DCAGD)",
          "duration": "6 MONTHS COMPUTER FUNDAMENTALS",
          "subjects": [
            ", IT & WINDOWS",
            "MS WORD",
            "MS EXCEL",
            "MS POWERPOINT",
            "MS OUTLOOK & INTERNET",
            "MS ACCESS",
            "ADOBE PHOTOSHOP, COREL DRAW, ILLUSTRATOR, CANVA PRO"
          ]
        },
        {
          "id": "27",
          "title": "CERTIFICATE IN UI/UX USING FIGMA",
          "duration": "3 MONTHS",
          "subjects": [
            "."
          ]
        },
        {
          "id": "28",
          "title": "ADVANCE DIPLOMA IN COMPUTER APPLICATION & PROGRAMMING (ADCAP)",
          "duration": "12 MONTHS COMPUTER FUNDAMENTS",
          "subjects": [
            ", IT, OS & WINDOWS",
            "MS OFFICE",
            "INTERNET",
            "TALLY ERP 9.0/ TALLY PRIME",
            "COMPUTER NETWORKING",
            "C++, HTML",
            "CSS, DBMS"
          ]
        },
        {
          "id": "29",
          "title": "MS POWERPOINT COURSE",
          "duration": "1 MONTH",
          "subjects": [
            "."
          ]
        },
        {
          "id": "30",
          "title": "PROFESSIONAL DIPLOMA IN INFORMATION TECHNOLOGY (PDIT)",
          "duration": "18 MONTHS",
          "subjects": [
            "."
          ]
        },
        {
          "id": "31",
          "title": "POST GRADUATE DIPLOMA IN SOFTWARE ENGINEERING (PDSE)",
          "duration": "24 MONTHS DATA ENGINEERING",
          "subjects": []
        },
        {
          "id": "32",
          "title": "DCA + TALLY ERP 9.0/TALLY PRIME",
          "duration": "6 MONTHS COMPUTER FUNDAMENTALS",
          "subjects": [
            ", IT, OS & WINDOWS",
            "MS WORD",
            "MS EXCEL",
            "MS POWERPOINT",
            "MS ACCESS",
            "INTERNET, OUTLOOK, HTML",
            "TALLY ERP 9.0/TALLY PRIME"
          ]
        },
        {
          "id": "33",
          "title": "COMPUTER TYPING (URDU & ENGLISH)",
          "duration": "06 MONTHS U",
          "subjects": [
            "rdu (Computer Typing)",
            "English (Computer Typing)"
          ]
        },
        {
          "id": "34",
          "title": "COMPUTER TYPING (MARATHI)",
          "duration": "03 MONTHS M",
          "subjects": [
            "arathi (Computer Typing)"
          ]
        },
        {
          "id": "35",
          "title": "COURSE IN HTLM, CSS CONCEPTS",
          "duration": "1 MONTH",
          "subjects": [
            "."
          ]
        },
        {
          "id": "36",
          "title": "COURSE IN PYTHON CONCEPTS",
          "duration": "1 MONTH",
          "subjects": [
            "."
          ]
        },
        {
          "id": "37",
          "title": "Programming in C Language Course",
          "duration": "3 MONTHS",
          "subjects": [
            "."
          ]
        },
        {
          "id": "38",
          "title": "ADVANCE EXCEL+",
          "duration": "6 MONTHS",
          "subjects": [
            "."
          ]
        },
        {
          "id": "39",
          "title": "ADVANCE DIPLOMA IN COMPUTER PROGRAMMING AND PUBLISHING (ADCPP)",
          "duration": "18 MONTHS",
          "subjects": [
            "."
          ]
        },
        {
          "id": "40",
          "title": "DIPLOMA IN ADVANCE ACCOUNTING (DAA)",
          "duration": "6 MONTHS FUNDAMENTALS",
          "subjects": [
            "-TALLY PRIME, LEDGER & JOURNAL",
            "COMPANY CREATION, P&L, BALANCE SHEET",
            "CASH BANK BOOK,INVENTORY CREATION,RECORD ENTRY",
            "PURCHASE-SALES WITH RETURN & ADJUSTMENT ENTRIES",
            "BILL ACCOUNT MAINTENANCE, PAYROLL, TDS, TCS",
            "GST-INTRODUCTION,CALCULATION,DEBIT/CREDIT NOTE",
            "MS EXCEL-INTRODUCTION,CUSTOMISING,FUNCTIONS",
            "FORMULAS,FUNCTIONS,DATA FORMATTING,LOOKUP FUNCTIONS",
            "VBA MACRO PROGRAMMING,PIVOT TABLE & PIVOT CHARTS"
          ]
        },
        {
          "id": "41",
          "title": "Advance JAVA",
          "duration": "6 MONTHS",
          "subjects": [
            "."
          ]
        },
        {
          "id": "42",
          "title": "ADVANCE DIPLOMA IN WEB DESIGNING (ADWD)",
          "duration": "12 MONTHS",
          "subjects": [
            "."
          ]
        },
        {
          "id": "43",
          "title": "CERTIFICATE IN COMPUTER APPLICATION (CCA)",
          "duration": "3 MONTHS",
          "subjects": [
            "."
          ]
        },
        {
          "id": "44",
          "title": "MASTER DIPLOMA IN COMPUTER SCIENCE (MDCS)",
          "duration": "12 MONTHS COMPUTER FUNDAMENTALS",
          "subjects": [
            ", IT & WINDOWS",
            "NOTE PAD, MS PAINT, INTERNET & MULTIMEDIA",
            "MS WORD, MS EXCEL & MS POWERPOINT",
            "PAGEMAKER, PHOTOSHOP, IMAGE READY",
            "COMPUTER TYPING (HINDI + ENGLISH)",
            "WEB DESIGNING BASICS",
            "ACCOUNTING & TALLY ERP 9.0/TALLY PRIME",
            "SPOKEN ENGLISH & PERSONALITY DEVELOPMENT"
          ]
        },
        {
          "id": "45",
          "title": "COMPUTER TYPING (BENGALI)",
          "duration": "3 MONTHS B",
          "subjects": [
            "engali (Computer Typing)"
          ]
        },
        {
          "id": "46",
          "title": "CERTIFICATE TYPING (GUJARATI & ENGLISH)",
          "duration": "06 MONTHS G",
          "subjects": [
            "ujrati (Computer Typing)",
            "English (Computer Typing)"
          ]
        },
        {
          "id": "47",
          "title": "Course in CANVA Operations",
          "duration": "1 MONTH",
          "subjects": [
            "."
          ]
        },
        {
          "id": "48",
          "title": "CERTIFICATE IN PRIMARY COMPUTER OPERATING (CIPCO)",
          "duration": "21 HOURS",
          "subjects": [
            "."
          ]
        },
        {
          "id": "49",
          "title": "CERTIFICATE IN AUTOCAD",
          "duration": "02 MONTHS 2D",
          "subjects": [
            ", 3D"
          ]
        },
        {
          "id": "50",
          "title": "DIPLOMA IN OFFICE AUTOMATION AND MANAGEMENT (DOAM)",
          "duration": "06 MONTHS COMPUTER FUNDAMENTAL",
          "subjects": [
            ", WINDOWS OS",
            "MS WORD",
            "MS EXCEL",
            "MS POWERPOINT",
            "MS ACCESS",
            "TALLY ERP 9.0/TALLY PRIME",
            "BUSINESS COMMUNICATION",
            "INTERNET TECHNOLOGY"
          ]
        },
        {
          "id": "51",
          "title": "CERTIFICATE IN MICROSOFT OFFICE (CMO)",
          "duration": "03 MONTHS COMPUTER CONCEPT",
          "subjects": [
            "& FUNDAMENTALS"
          ]
        },
        {
          "id": "52",
          "title": "DIPLOMA IN COMPUTER PROFESSIONAL ACCOUNTANT (DCPA)",
          "duration": "06 MONTHS VAT",
          "subjects": [
            ", TDS, SERVICE TAX",
            "COMPUTER CONCEPT, FUNDAMENTAL & INTERNET",
            "INTRODUCTION OF ACCOUNTING",
            "TALLY WITH GST",
            "FINAL ACCOUNTS"
          ]
        },
        {
          "id": "53",
          "title": "DIPLOMA IN COMPUTER OFFICE MANAGEMENT (DCOM)",
          "duration": "12 MONTHS COMPUTER FUNDAMENTALS",
          "subjects": [
            ", IT, OPERATING SYSTEM & WINDOWS",
            "MS WORD",
            "MS EXCEL",
            "MS POWERPOINT",
            "MS OUTLOOK & INTERNET",
            "MS ACCESS, BASICS OF C PROGRAMMING LANGUAGE",
            "TALLY ERP 9.0",
            "ADOBE PAGEMAKER, ADOBE PHOTOSHOP, COREL DRAW"
          ]
        },
        {
          "id": "54",
          "title": "DIPLOMA IN COMPUTER APPLICATION+ (DCA+)",
          "duration": "12 MONTHS COMPUTER FUNDAMENTALS",
          "subjects": [
            ", IT & WINDOWS",
            "MS WORD, MS EXCEL & ms POWERPOINT",
            "MS OUTLOOK, MS ACCESS",
            "HTML, BASICS OF C LANGUAGE",
            "Internet & E-MAIL"
          ]
        },
        {
          "id": "55",
          "title": "COMPUTER TYPING (ENGLISH & BENGALI)",
          "duration": "06 MONTHS E",
          "subjects": [
            "nglish (Computer Typing)",
            "Bengali (Computer Typing)"
          ]
        },
        {
          "id": "56",
          "title": "COMPUTER TYPING (HINDI)",
          "duration": "03 MONTHS H",
          "subjects": [
            "indi (Computer Typing)"
          ]
        },
        {
          "id": "57",
          "title": "CERTIFICATE IN GRAPHIC DESIGN",
          "duration": "06 MONTHS GRAPHIC DESIGNING FUNDAMENTALS",
          "subjects": [
            "ADOBE PHOTOSHOP CS",
            "DESIGNING ELEMENTS",
            "ADOBE COREL DRAW",
            "ADOBE ILLUSTRATOR"
          ]
        },
        {
          "id": "58",
          "title": "JAVA CONCEPTS",
          "duration": "1 MONTH",
          "subjects": []
        },
        {
          "id": "59",
          "title": "DIPLOMA IN COMPUTER OPERATIONS",
          "duration": "06 MONTHS",
          "subjects": [
            "."
          ]
        },
        {
          "id": "60",
          "title": "ADVANCE DIPLOMA IN COMPUTER APPLICATION+ (ADCA+)",
          "duration": "12 MONTHS COMPUTER FUNDAMENTALS",
          "subjects": [
            ", IT & WINDOWS",
            "MS WORD, EXCEL, POWER POINT, ACCESS",
            "TALLY ERP 9.0/TALLY PRIME",
            "PAGEMAKER, PHOTOSHOP, COREL DRAW",
            "CONCEPTS OF C, C++",
            "JAVA, PYTHON",
            "HTML, INTERNET"
          ]
        },
        {
          "id": "61",
          "title": "ADVANCE EXCEL",
          "duration": "02 MONTHS EXCEL",
          "subjects": []
        },
        {
          "id": "62",
          "title": "COMPUTER TYPING (PUNJABI)",
          "duration": "3 MONTHS P",
          "subjects": [
            "unjabi (Computer Typing)"
          ]
        },
        {
          "id": "63",
          "title": "CERTIFICATE IN STENOGRAPHY",
          "duration": "CERTIFICATE IN STENOGRAPHY",
          "subjects": []
        },
        {
          "id": "64",
          "title": "DIPLOMA IN INFORMATION TECHNOLOGY (DIT)",
          "duration": "6 MONTHS C",
          "subjects": [
            "& C++ LANGUAGE",
            "DTP",
            "HTML & JAVA",
            "MS OFFICE",
            "TALLY",
            "VISUAL BASIC"
          ]
        },
        {
          "id": "65",
          "title": "COMPUTER TYPING (ENGLISH)",
          "duration": "03 MONTHS E",
          "subjects": [
            "nglish (Computer Typing)"
          ]
        },
        {
          "id": "66",
          "title": "BASIC COMPUTER COURSE (BCC)",
          "duration": "3 MONTHS",
          "subjects": []
        },
        {
          "id": "67",
          "title": "DIPLOMA IN COMPUTER APPLICATION (DCA)",
          "duration": "06 MONTHS COMPUTER FUNDAMENTALS",
          "subjects": [
            ", IT & WINDOWS",
            "MS WORD",
            "MS EXCEL",
            "MS POWERPOINT",
            "MS OUTLOOK & INTERNET",
            "MS ACCESS"
          ]
        },
        {
          "id": "68",
          "title": "ADVANCE DIPLOMA IN COMPUTER APPLICATION (ADCA)",
          "duration": "12 MONTHS COMPUTER FUNDAMENTALS",
          "subjects": [
            ", IT & WINDOWS",
            "MS WORD",
            "MS EXCEL",
            "MS POWERPOINT",
            "MS OUTLOOK & INTERNET",
            "MS ACCESS",
            "TALLY ERP 9.0/TALLY PRIME",
            "PAGEMAKER, PHOTOSHOP, COREL DRAW"
          ]
        },
        {
          "id": "69",
          "title": "DIPLOMA IN DESKTOP PUBLISHING (DDP)",
          "duration": "6 MONTHS",
          "subjects": []
        },
        {
          "id": "70",
          "title": "C & C++",
          "duration": "3 MONTHS",
          "subjects": []
        },
        {
          "id": "71",
          "title": "PHP",
          "duration": "3 MONTHS",
          "subjects": []
        },
        {
          "id": "72",
          "title": "PG DIPLOMA IN COMPUTER APPLICATION (PGDCA)",
          "duration": "12 MONTHS COMPUTER FUNDAMENTALS",
          "subjects": [
            ", IT & WINDOWS",
            "MS WORD, EXCEL, POWER POINT, ACCESS",
            "TALLY ERP 9.0",
            "PAGEMAKER, PHOTOSHOP, COREL DRAW",
            "CONCEPTS OF C, C++",
            "CONCEPTS OF HARDWARE & NETWORKING",
            "HTML, INTERNET, MULTIMEDIA"
          ]
        },
        {
          "id": "73",
          "title": "DIPLOMA IN AUTOCAD (CIVIL)",
          "duration": "12 MONTHS",
          "subjects": [
            "- BASICS & FUNDAMNETALS OF AUTOCAD 2D & 3D - COMMANDS, EDITING TOOLS - PROJECT ANALYSIS & QUOTATION - VIVA - ASSIGNMENTS"
          ]
        },
        {
          "id": "74",
          "title": "CAD/CAM",
          "duration": "6 MONTHS",
          "subjects": []
        },
        {
          "id": "75",
          "title": "COMPUTER TYPING (HINDI & ENGLISH)",
          "duration": "6 MONTHS H",
          "subjects": [
            "indi (Computer Typing)",
            "English (Computer Typing)"
          ]
        },
        {
          "id": "76",
          "title": "CERTIFICATE IN WEB DESIGNING (CWD)",
          "duration": "3 MONTHS",
          "subjects": []
        },
        {
          "id": "77",
          "title": "DIPLOMA IN WEB DESIGNING (DWD)",
          "duration": "6 MONTHS",
          "subjects": [
            "."
          ]
        },
        {
          "id": "78",
          "title": "ADVANCE DIPLOMA IN INFORMATION TECHNOLOGY (ADIT)",
          "duration": "12 MONTHS FUNDAMENTALS OF COMPUTER",
          "subjects": [
            ", WINDOWS & OS",
            "MS WORD, MS EXCEL, MS POWERPOINT",
            "OUTLOOK, MS ACCESS",
            "ADOBE PHOTOSHOP, CORELDRAW, INDESIGN, PAGEMAKER",
            "C++, JAVA, INTRODUCTION TO VB.NET",
            "PC TROUBLESHOOTING",
            "TALLY ERP 9/ TALLY PRIME"
          ]
        },
        {
          "id": "79",
          "title": "MASTER DIPLOMA IN INFORMATION TECHNOLOGY (MDIT)",
          "duration": "12 MONTHS COMPUTER FUNDAMENTALS",
          "subjects": [
            ",IT,OS & WINDOWS",
            "MS-OFFICE, INTERNET & MULTIMEDIA",
            "PAGEMAKER, PHOTOSHOP AND COREL DRAW",
            "TALLY ERP 9.0/TALLY PRIME",
            "INTRODUCTION TO C & PROGRAMMING",
            "WEB DESIGNING",
            "COMPUTER HARDWARE & NETWORKING",
            "COMMUNICATION SKILLS"
          ]
        },
        {
          "id": "80",
          "title": "DIPLOMA IN COMPUTER TEACHER TRAINING (DCTT)",
          "duration": "12 MONTHS COMPUTER FUNDAMENTALS",
          "subjects": [
            ", IT & WINDOWS",
            "MS WORD, EXCEL, POWER POINT, ACCESS",
            "TALLY ERP 9.0/TALLY PRIME",
            "ADOBE PAGEMAKER, PHOTOSHOP, COREL DRAW",
            "CONCEPTS OF C, C++",
            "JAVA SCRIPT, PYTHON",
            "HTML, INTERNET"
          ]
        },
        {
          "id": "81",
          "title": "CERTIFICATE IN OFFICE MANAGEMENT (COM)",
          "duration": "3 MONTHS",
          "subjects": []
        },
        {
          "id": "82",
          "title": "DIPLOMA IN OFFICE MANAGEMENT (DOM)",
          "duration": "6 MONTHS",
          "subjects": []
        },
        {
          "id": "83",
          "title": "MASTER DIPLOMA IN OFFICE MANAGEMENT (MDOM)",
          "duration": "12 MONTHS PRINCIPLES OF MANAGEMENT",
          "subjects": [
            ", OFFICE PROCEDURE AND SUPERVISORY SKILLS",
            "IT APPLICATIONS AND E-SYSTEM, HR MANAGEMENT AND BUSINESS REGULATORY FRAMEWORK",
            "MANAGEMENT CONCEPT OF SALES AND MARKETING",
            "MANAGEMENT CONCEPT OF ORGANISATIONAL BEHAVIOUR, CORPORATE MANAGEMENT",
            "FINANCE MANAGEMENT, HUMAN RESOURCE MANAGEMENT",
            "RURAL MANAGEMENT, RETAIL MANAGEMENT",
            "BUSINESS DESIGN AND INNOVATION"
          ]
        },
        {
          "id": "84",
          "title": "DIPLOMA IN OFFICE AUTOMATION (DOA)",
          "duration": "6 MONTHS",
          "subjects": []
        },
        {
          "id": "85",
          "title": "MASTER DIPLOMA IN OFFICE AUTOMATION (MDOA)",
          "duration": "12 MONTHS",
          "subjects": []
        },
        {
          "id": "86",
          "title": "CERTIFICATE IN DATA ENTRY OPERATOR",
          "duration": "6 MONTHS",
          "subjects": [
            "."
          ]
        },
        {
          "id": "87",
          "title": "DIPLOMA IN COMPUTER PROGRAMMING (DCP)",
          "duration": "6 MONTHS",
          "subjects": []
        },
        {
          "id": "88",
          "title": "COURSE ON COMPUTER CONCEPTS (CCC)",
          "duration": "3 MONTHS FUNDAMENTALS OF COMPUTER",
          "subjects": [
            ", IT, WINDOWS, OPERATING SYSTEM",
            "MS OFFICE",
            "INSTALLATION & TROUBLESHOOTING",
            "INTERNET"
          ]
        },
        {
          "id": "89",
          "title": "PROFESSIONAL DIPLOMA IN DESKTOP PUBLISHING & COMPUTER APPLICATION (PDDPCA)",
          "duration": "12 MONTHS COMPUTER FUNDAMENTALS",
          "subjects": [
            ", IT, OS & WINDOWS",
            "MS WORD",
            "MS EXCEL",
            "MS POWERPOINT",
            "OUTLOOK, ACCESS & INTERNET",
            "DATA ENTRY",
            "PAGEMAKER, PHOTOSHOP, COREL DRAW"
          ]
        },
        {
          "id": "90",
          "title": "PROFESSIONAL DIPLOMA IN DESKTOP PUBLISHING & ACCOUNTANCY (PDDPA)",
          "duration": "12 MONTHS",
          "subjects": []
        },
        {
          "id": "91",
          "title": ".(DOT) NET",
          "duration": "3 MONTHS",
          "subjects": []
        },
        {
          "id": "92",
          "title": "JAVA",
          "duration": "3 MONTHS",
          "subjects": []
        },
        {
          "id": "93",
          "title": "PROGRAMMING IN PYTHON COURSE",
          "duration": "3 MONTHS",
          "subjects": [
            "."
          ]
        },
        {
          "id": "94",
          "title": "DIPLOMA IN DIGITAL MARKETING",
          "duration": "6 MONTHS",
          "subjects": [
            "."
          ]
        },
        {
          "id": "95",
          "title": "ADVANCE DIPLOMA IN BRANDING & DIGITAL MARKETING",
          "duration": "12 MONTHS INTRODUCTION",
          "subjects": [
            "- DIGITAL MARKETING, BRANDING & BRAND MANAGEMENT, CUSTOMER PERCEPTION",
            "DIGITAL MARKETING & BRANDING STRATEGY & ARCHITECTURE, BUILDING IMAGE",
            "BRANDING ETHICS, GRAPHIC DESIGN IN BRANDING, BRANDING & DIGITAL MARKETING TOOLS",
            "SEO, SEM, INTERNET MARKETING, SOCIAL MEDIA MARKETING & MANAGEMENT, KEYWORDS",
            "CAMPAIGNS PLANNING, GOOGLE ADWORDS, CONTENT MARKETING, VIDEO MARKETING",
            "ONLINE BRAND BUILDING & MANAGEMENT, ONLINE LEAD GENERATION",
            "GOOGLE ADWORDS & ADSENCE, EMAIL MARKETING"
          ]
        },
        {
          "id": "96",
          "title": "SEO & SEM",
          "duration": "6 MONTHS",
          "subjects": []
        },
        {
          "id": "97",
          "title": "DIPLOMA IN SOCIAL MEDIA MANAGEMENT",
          "duration": "6 MONTHS",
          "subjects": []
        },
        {
          "id": "98",
          "title": "MySQL",
          "duration": "3 MONTHS",
          "subjects": []
        },
        {
          "id": "99",
          "title": "VB.(DOT ) NET",
          "duration": "3 MONTHS",
          "subjects": []
        },
        {
          "id": "100",
          "title": "CORE JAVA",
          "duration": "3 MONTHS",
          "subjects": []
        },
        {
          "id": "101",
          "title": "ASP.(DOT) NET",
          "duration": "3 MONTHS",
          "subjects": []
          
        }
    ]
},
{
    "type":"Financial Courses",
    "courses":[
                {
                  "id": "1",
                  "title": "CORPORATE ACCOUNTING WITH SAP BUSINESS ONE",
                  "duration": "3 MONTHS CORPORATE ACCOUNTING",
                  "subjects": [
                    "SAP BUSINESS ONE"
                  ]
                },
                {
                  "id": "2",
                  "title": "USING TALLY ERP 9.0 IN ACCOUNTING COURSE",
                  "duration": "6 MONTHS INTRODUCTION",
                  "subjects": [
                    ", SHORTCUTS, TALLY STARTUP",
                    "LEDGER, VOUCHER, JOURNAL ENTRY",
                    "STOCK, IMPORTANT POINTS FOR PURCHASE AND SALE",
                    "INTEREST CALCULATION",
                    "GOODS AND SERVICES TAX"
                  ]
                },
                {
                  "id": "3",
                  "title": "DIPLOMA COURSE IN FINANCIAL ACCOUNTING (DCFA)",
                  "duration": "6 MONTHS FUNDAMENTALS OF ACCOUNTING",
                  "subjects": [
                    "TALLY PRIME (FINANCIAL ACCOUNTING, INVENTORY)",
                    "TALLY PRIME (GST & PAYTOLL MANAGEMENT)",
                    "TALLY PRIME (GST RETURN)",
                    "TALLY PRIME (TDS & TCS TAXATION)",
                    "ADVANCE EXCEL (DATA ANALYSIS)"
                  ]
                },
                {
                  "id": "4",
                  "title": "ADVANCE DIPLOMA IN COMPUTER APPLICATION & FINANCIAL ACCOUNTING (ADCAFA)",
                  "duration": "12 MONTHS COMPUTER FUNDAMENTALS",
                  "subjects": [
                    ", IT & WINDOWS",
                    "MS WORD",
                    "MS EXCEL",
                    "MS POWERPOINT",
                    "MS OUTLOOK, MS ACCESS & INTERNET",
                    "ADVANCED EXCEL (DATA ANALYSIS)",
                    "TALLY PRIME (FINANCIAL ACCOUNTING, INVENTORY MANAGEMENT)",
                    "TALLY PRIME (PAYROLL MANAGEMENT, GST TAXATION & GST RETURN)",
                    "TALLY PRIME (TDC & TCS TAXATION, GST RETURN)"
                  ]
                },
                {
                  "id": "5",
                  "title": "DIPLOMA IN COMPUTER APPLICATION & FINANCIAL ACCOUNTING (DCAFA)",
                  "duration": "6 MONTHS COMPUTER FUNDAMENTALS",
                  "subjects": [
                    ", IT & WINDOWS",
                    "MS WORD",
                    "MS EXCEL",
                    "MS POWERPOINT",
                    "MS OUTLOOK & INTERNET",
                    "MS ACCESS",
                    "TALLY PRIME (FINANCIAL ACCOUNTING, INVENTORY MANAGEMENT)",
                    "TALLY PRIME (GST & PAYROLL MANAGEMENT)"
                  ]
                },
                {
                  "id": "6",
                  "title": "PROFESSIONAL DIPLOMA IN BUSINESS ACCOUNTING & ADMINISTRATION (PDBAA)",
                  "duration": "6 MONTHS FINANCIAL ACCOUNTING",
                  "subjects": [
                    "COST ESTIMATION AND EVALUATION",
                    "MS WORD",
                    "MS EXCEL",
                    "MS POWERPOINT",
                    "TALLY ERP 9.0/PRIME",
                    "BUSINESS ADMINISTRATION"
                  ]
                },
                {
                  "id": "7",
                  "title": "SAP FICO",
                  "duration": "3 MONTHS",
                  "subjects": [
                    "."
                  ]
                },
                {
                  "id": "8",
                  "title": "INDUSTRIAL ACCOUNTANT EXPRESS (IAE)",
                  "duration": "8 MONTHS B",
                  "subjects": [
                    "asic Computer",
                    "Industrial excel",
                    "Basic accounting",
                    "Basic tally prime",
                    "Advance tally prime"
                  ]
                },
                {
                  "id": "9",
                  "title": "INDUSTRIAL ACCOUNTANT COURSE (IAC)",
                  "duration": "10 MONTHS BASIC COMPUTER",
                  "subjects": [
                    "INDUSTRIAL EXCEL",
                    "BASIC ACCOUNTING",
                    "BASIC TALLY PRIME",
                    "ADVANCE TALLY PRIME",
                    "TAX DEDUCTION AT SOURCE (TDS)",
                    "GOODS AND SERVICE TAX (GST)"
                  ]
                },
                {
                  "id": "10",
                  "title": "TALLY PRIME",
                  "duration": "3 MONTHS FUNDAMENTALS",
                  "subjects": [
                    "-TALLY PRIME,LEDGER GROUP,JOURNAL ENTRY",
                    "COMPANY CREATION & BACKUP RESTORE,P&L,BALANCE SHEET",
                    "CASH-BANK BOOK WITH DISCOUNT COLUMN,INVENTORY CREATION & RECORD ENTRY",
                    "PURCHASE & SALES WITH RETURN ENTRY,ADJUSTMENT ENTRY",
                    "BILL ACCOUNT MAINTAINING,PAYROLL,TDS,TCS",
                    "GST-INTRODUCTION,CALCULATION,DEBIT/CREDIT NOTE"
                  ]
                },
                {
                  "id": "11",
                  "title": "BUSY",
                  "duration": "03 MONTHS BUSY",
                  "subjects": []
                },
                {
                  "id": "12",
                  "title": "ADVANCED TALLY",
                  "duration": "06 MONTHS",
                  "subjects": [
                    "."
                  ]
                },
                {
                  "id": "13",
                  "title": "CERTIFICATE IN FINANCIAL ACCOUNTING (CFA)",
                  "duration": "04 MONTHS FUNDAMENTALS OF COMPUTER",
                  "subjects": [
                    "BASICS OF ACCOUNTING",
                    "FUNDAMENTALS OF TALLY",
                    "GOODS AND SERVICES TAX",
                    "TAX DEDUCTED AT SOURCE"
                  ]
                },
                {
                  "id": "14",
                  "title": "TALLY ERP 9.0",
                  "duration": "3 MONTHS FUNDAMENTALS OF TALLY",
                  "subjects": [
                    ", BASICS OF ACCOUNTING",
                    "BOOK KEEPING, F.A REPORTS, INCOME & EXPENSES",
                    "CASH FLOW, CREDIT MANAGEMENT, RATIO ANALYSIS",
                    "RECEIVABLE & PAYABLE, DEBTORS PAYMENT",
                    "ORDERS, INVOICE, VOUCHERS",
                    "TAX DEDUCTION AT SOURCE",
                    "GOODS & SERVICES TAX"
                  ]
                },
                {
                  "id": "15",
                  "title": "DIPLOMA IN FINANCIAL ACCOUNTING (DFA)",
                  "duration": "9 MONTHS COMPUTER FUNDAMENTALS",
                  "subjects": [
                    ", IT & WINDOWS",
                    "MS WORD",
                    "MS EXCEL",
                    "MS POWERPOINT",
                    "MS OUTLOOK & INTERNET",
                    "MS ACCESS",
                    "TALLY ERP 9.0/TALLY PRIME"
                  ]
                },
                {
                  "id": "16",
                  "title": "ADVANCE DIPLOMA IN FINANCIAL ACCOUNTING (ADFA)",
                  "duration": "12 MONTHS COMPUTER FUNDAMENTAL IT",
                  "subjects": [
                    "& WINDOWS",
                    "MS WORDS, MS EXCEL",
                    "MS POWER POINT, MS OUTLOOK & INTERNET",
                    "TALLY ERP9.0 & INVENTORY",
                    "G.S.T - IGST, CGST , SGST, PAYROLL",
                    "SERVICE TAX , BUSY SOFTWARE"
                  ]
                },
                {
                  "id": "17",
                  "title": "DIPLOMA IN BUSINESS ACCOUNTING (DBA)",
                  "duration": "6 MONTHS COMPUTER FUNDAMENTALS",
                  "subjects": [
                    ", IT & WINDOWS",
                    "MS WORD",
                    "MS EXCEL",
                    "MS POWERPOINT",
                    "MS OUTLOOK & INTERNET , MS ACCESS",
                    "TALLY ERP 9.0"
                  ]
                },
                {
                  "id": "18",
                  "title": "ADVANCE DIPLOMA IN BUSINESS ACCOUNTING (ADBA)",
                  "duration": "12 MONTHS",
                  "subjects": []
                },
                {
                  "id": "19",
                  "title": "ADVANCE DIPLOMA IN APPLIED FINANCE & ACCOUNTING WITH GST",
                  "duration": "12 MONTHS",
                  "subjects": []
                },
                {
                  "id": "20",
                  "title": "DIPLOMA IN APPLIED FINANCE & ACCOUNTING WITH GST",
                  "duration": "6 MONTHS",
                  "subjects": []
                },
                {
                  "id": "21",
                  "title": "DIPLOMA IN COMPUTER PROGRAMMING & ACCOUNTING",
                  "duration": "6 MONTHS",
                  "subjects": []
                },
                {
                  "id": "22",
                  "title": "ADVANCE DIPLOMA IN COMPUTER PROGRAMMING & ACCOUNTING",
                  "duration": "12 MONTHS",
                  "subjects": []
                },
                {
                  "id": "23",
                  "title": "DIPLOMA IN ACCOUNTING & TAXATION",
                  "duration": "6 MONTHS",
                  "subjects": []
                },
                {
                  "id": "24",
                  "title": "PROFESSIONAL DIPLOMA IN ACCOUNTING & TAXATION",
                  "duration": "12 MONTHS",
                  "subjects": [
                    "."
                  ]
                },
                {
                  "id": "25",
                  "title": "DIPLOMA IN ACCOUNTING & BOOK KEEPING",
                  "duration": "6 MONTHS",
                  "subjects": []
                }
    ]
},
{
    "type":"Hardware and Networking Courses",
    "courses": [
        {
            "id": "1",
            "title": "DIPLOMA IN CYBER SECURITY (DCS)",
            "duration": "12 MONTHS KALI LINUX",
            "subjects": [
              "(OS)",
              "CERTIFIED ETHICAL HACKING",
              "RED HAT (RHCSA)",
              "WEB DEVELOPER",
              "DATABASE CONCEPT",
              "CLOUD SERVICES",
              "WEB PENETRATION TESTING",
              "NETWORK PENETRATION TESTING",
              "INTERVIEW PREPARATION"
            ]
          },
          {
            "id": "2",
            "title": "DIPLOMA IN CHIP/CARD LEVEL REPAIRING",
            "duration": "6 MONTHS",
            "subjects": []
          },
          {
            "id": "3",
            "title": "BASIC COURSE IN HARDWARE & NETWORKING (BCHN)",
            "duration": "3 MONTHS",
            "subjects": []
          },
          {
            "id": "4",
            "title": "DIPLOMA IN HARDWARE & NETWORKING (DHN)",
            "duration": "6 MONTHS",
            "subjects": []
          },
          {
            "id": "5",
            "title": "ADVANCE DIPLOMA IN HARDWARE & NETWORKING (ADHN)",
            "duration": "12 MONTHS COMPUTER HARDWARE",
            "subjects": [
              "& MAINTENANCE",
              "PC ASSEMBLING & TROUBLESHOOTING",
              "WINDOWS 2007 SERVER ADMINISTRATION",
              "NETWORK ADMINISTRATION",
              "DIGITAL ELECTRONICS & MEASURING INSTRUMENTS"
            ]
          },
          {
            "id": "6",
            "title": "DIPLOMA IN MOBILE PHONE REPAIRING",
            "duration": "6 MONTHS",
            "subjects": []
          },
          {
            "id": "7",
            "title": "DIPLOMA IN LAPTOP REPAIRING",
            "duration": "6 MONTHS",
            "subjects": []
          },
          {
            "id": "8",
            "title": "PROFESSIONAL DIPLOMA IN CHIP/CARD LEVEL REPAIRING WITH NETWORKING",
            "duration": "12 MONTHS",
            "subjects": []
          },
          {
            "id": "9",
            "title": "ETHICAL HACKING",
            "duration": "12 MONTHS",
            "subjects": []
          },
          {
            "id": "10",
            "title": "CERTIFICATE IN CYBER SECURITY (CCS)",
            "duration": "6 MONTHS",
            "subjects": []
          },
          {
            "id": "11",
            "title": "LINUX",
            "duration": "3 MONTHS",
            "subjects": []
          },
          {
            "id": "12",
            "title": "CERTIFICATE IN COMPUTER ASSEMBLING & SOFTWARE INSTALLATION (CCASI)",
            "duration": "3 MONTHS",
            "subjects": []
          }
    ]
},
{
    "type":"Multimedia and Graphics Courses",
    "courses":[
        {
            "id": "1",
            "title": "ADVANCE DIPLOMA IN GRAPHIC DESIGNING",
            "duration": "12 MONTHS",
            "subjects": []
          },
          {
            "id": "2",
            "title": "DIPLOMA IN 3D ANIMATION",
            "duration": "12 MONTHS FUNDAMENTALS OF ANIMATION",
            "subjects": [
              "CHARACTER DESIGNING",
              "GRAPHIC DESIGNING",
              "3D MODELLING AND ANIMATION",
              "INTRODUCTION TO MAYA"
            ]
          },
          {
            "id": "3",
            "title": "CERTIFICATE IN PHOTOSHOP (CIP)",
            "duration": "3 MONTHS",
            "subjects": [
              "."
            ]
          },
          {
            "id": "4",
            "title": "DIPLOMA IN GRAPHIC DESIGNING & DIGITAL MARKETING BASICS (DGDDMB)",
            "duration": "6 MONTHS ADOBE PHOTOSHOP",
            "subjects": [
              "ADOBE ILLUSTRATOR",
              "CANVA PRO",
              "ADOBE PREMIERE PRO",
              "BASICS OF DIGITAL MARKETING",
              "ONE PAGE WEBSITE, LOGO, POSTER, LANDING PAGE DESIGNING"
            ]
          },
          {
            "id": "5",
            "title": "DIPLOMA IN GRAPHIC DESIGN & VIDEO EDITING (DGDVE)",
            "duration": "18 MONTHS FUNDAMENTALS OF GRAPHIC DESIGNING",
            "subjects": [
              "MOTION GRAPHICS",
              "ADOBE INDESIGN",
              "ADOBE PHOTOSHOP",
              "ADOBE ILLUSTRATOR",
              "ADOBE PREMIER PRO"
            ]
          },
          {
            "id": "6",
            "title": "ADVANCE DIPLOMA IN DIGITAL MARKETING",
            "duration": "24 MONTHS INTRODUCTION TO DIGITAL MARKETING",
            "subjects": [
              ", TOOLS",
              "E-MAIL & SOCIAL MEDIA MARKETING, SEO, SEM",
              "WEB ANALYTICS, PLANNING CAMPAIGNS",
              "CONTENTS & E-COMMERCE MARKETING, KEYWORDS",
              "AFFILIATE MARKETING, REPUTATION MANAGEMENT",
              "BLOGGING, INFLUENCER MARKETING, GOOGLE ADSENSE",
              "PODCAST, CAMPAIGN AUTOMATION, GOOGLE ADWORDS",
              "E-COMMERCE PRODUCT LISTING AND SELLING",
              "LEAD GENERATION, CHATBOT, QUORA MARKETING"
            ]
          },
          {
            "id": "7",
            "title": "CERTIFICATE IN PHOTOGRAPHY",
            "duration": "3 MONTHS",
            "subjects": []
          },
          {
            "id": "8",
            "title": "DIPLOMA IN PHOTOGRAPHY",
            "duration": "12 MONTHS",
            "subjects": []
          },
          {
            "id": "9",
            "title": "DIPLOMA IN GRAPHIC DESIGNING & ANIMATION",
            "duration": "12 MONTHS",
            "subjects": []
          },
          {
            "id": "10",
            "title": "PROFESSIONAL DIPLOMA IN ANIMATION",
            "duration": "12 MONTHS",
            "subjects": []
          },
          {
            "id": "11",
            "title": "CERTIFICATE IN VIDEO EDITING & MIXING",
            "duration": "6 MONTHS",
            "subjects": []
          },
          {
            "id": "12",
            "title": "PROFESSIONAL DIPLOMA IN GAME DESIGNING & INTEGRATION",
            "duration": "12 MONTHS",
            "subjects": []
          },
          {
            "id": "13",
            "title": "DIPLOMA IN MULTIMEDIA DESIGNING",
            "duration": "6 MONTHS",
            "subjects": []
          },
          {
            "id": "14",
            "title": "CERTIFICATE COURSE IN DIGITAL ADVERTISEMENT DESIGN & MARKETING",
            "duration": "6 MONTHS",
            "subjects": []
          }
    ]
},
{
  "type":"NTT Yoga Teacher Training Courses",
  "courses":[
    {
      "id":"1",
      "title":"Advance Diploma in Nursery Teacher Training (ADNTT)",
      "duration":"12 MONTHS",
      "subjects":[]
    },
    {
      "id":"2",
      "title":"Diploma in Yoga Training",
      "duration":"12 MONTHS",
      "subjects":[
        "YOGA"
      ]
    }
  ]
}
]
    

